import React from 'react';
import Webcam from "react-webcam";
import './PlayButton.css';
import Popup from 'reactjs-popup';

  
function Silence() {
    return (
      
      <div className="App">
        <header className="App-header">

        <strong>Silence Simulator</strong>

        <Popup
    trigger={<button className="button"> Info </button>}
    modal
    nested
    defaultOpen
  >
    {close => (
      <div className="modal">
        <div className="header"> <strong> Silence Simulator </strong> </div>
        <div className="content">
          {' '}
          We trained a generative ML model with 18 billion parameters on 240,000 audio files of silence. The entire process produced more carbon dioxide than the country of Greenland during its entire existence. However, now that we have the best silence simulator in the world, we can say it was all worth it
          <br />
          <br />

        </div>
        <div className="actions">
          <button
            className="button"
            onClick={() => {
              console.log('modal closed ');
              close();
            }}
          >
            Let's Get Started!
          </button>
        </div>
      </div>
    )}
  </Popup>

      <br />

        <a class = "play-btn" href = "#"></a>
        </header>

        
      </div>
    );
}
  
  export default Silence;
  